<template>
  <div id="publishing-special-issue-detail">
    <ipub-model width="990px"
                :visable="isVisable"
                :showHeader="false"
                :showFooter="false"
                @cancel="cancel">
      <div class="ipub-h1"
           style="max-width:800px"
           v-html="inputData.title"></div>
      <div class="ipub-p3 font-color mar-b-20">{{inputData.journal}}</div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:200px">Hierarchy</div>
        <div class="mar-l-10"
             style="width:calc(100% - 120px)">{{inputData.sort || 0}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:200px">Start Date</div>
        <div class="mar-l-10"
             style="width:calc(100% - 120px)">
          {{inputData.startTime?$moment(inputData.startTime).format('MMMM DD YYYY'):'--'}}
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:200px">Submission Deadline</div>
        <div class="mar-l-10"
             style="width:calc(100% - 120px)">
          {{inputData.endTime?$moment(inputData.endTime).format('MMMM DD YYYY'):'--'}}
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:200px">Special Issue Information</div>
        <div class="mar-l-10"
             style="width:calc(100% - 120px)">
          <div v-if="inputData.summary"
               v-html="inputData.summary"></div>
          <template v-else>--</template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:200px">Keywords</div>
        <div class="mar-l-10"
             style="width:calc(100% - 120px)">
          <span v-if="inputData.keyword">
            {{inputData.keyword}}
            <!-- <ipub-label :style="{margin: '5px 0 5px 8px'}"
                        v-for="(item, index) in inputData.keyword.split(',')"
                        :key="'specialIssue.keywords'+index"
                        size="common"
                        circle>{{item}}
            </ipub-label> -->
          </span>
          <template v-else>--</template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:200px">Flyer</div>
        <div class="mar-l-10"
             style="width:calc(100% - 120px)">
          <a v-if="inputData.flyer"
             :href="`${domain}/${inputData.flyer}`"
             class="link-color ipub-label ipub-label--small">{{inputData.flyerName}}</a>
          <template v-else>--</template>
        </div>
      </div>
      <div class="guest-editor-list mar-b-20 flex">
        <div class="ipub-p2 fw-bd mar-b-20"
             style="width:200px">Guest Editor</div>
        <div class="guest-editor-list-item flex"
             style="width:calc(100% - 120px)"
             v-for="(item, index) in inputData.editorList"
             :key="'inputData.editorList'+item.id || index">
          <div class="guest-editor-list-item-avatar">
            <img :src="`${domain}/${item.icon||'imageFile/icon.svg'}`"
                 alt="">
          </div>
          <div class="guest-editor-list-item-content">
            <div class="ipub-p1 mar-b-12">
              Dr. {{item.firstName}} {{item.lastName}}
              <font class="ipub-p2">
                <ipub-icon class="mar-l-10 warning-color"
                           type='iconHigh-index' />
                <ipub-icon class="mar-l-20 link-color"
                           type='iconEmail' />
                <ipub-icon class="mar-l-10 link-color"
                           type='iconWebsite' />
                <ipub-icon class="mar-l-10 link-color"
                           type='iconProfile' />
              </font>
            </div>
            <div class="ipub-p4 font-color mar-b-12">
              {{item.affiliation}}
            </div>
            <div class="ipub-p4 font-color mar-b-12">
              {{item.interest}}
            </div>
          </div>
        </div>
      </div>
      <div class="planned-paper-list">
        <div class="flex mar-b-10 ipub-p2 mar-b-20"
             v-for="(item, index) in inputData.particleList"
             :key="'inputData.particleList'+item.id||index">
          <div class="fw-bd"
               style="width:200px">Planned Article</div>
          <div class="mar-l-10"
               style="width:calc(100% - 120px)">
            <div class="ipub-h3"
                 v-html="item.title"></div>
            <div v-html="item.name"></div>
            <div v-html="item.summary"></div>
          </div>
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      editorialBoard: 'getEditorialBoard'
    })
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
#publishing-special-issue-detail {
  .guest-editor-list {
    &-item {
      &-avatar {
        font-size: 70px;
        margin: 0 -5px;
        color: $font-color;
        img {
          border-radius: 4px;
          width: 60px;
          height: 70px;
          object-fit: cover;
          margin: 0 5px;
        }
      }
      // &-img {
      //   border-radius: 50%;
      //   height: 60px;
      //   width: 60px;
      //   font-size: 70px;
      //   margin-left: 45px;
      //   color: $line_color;
      //   background: $font_color;
      //   overflow: hidden;
      //   display: flex;
      //   justify-content: center;
      //   align-items: center;
      // }
      &-content {
        width: calc(100% - 80px);
        margin-left: 20px;
      }
    }
  }
}
</style>
